import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const apiKey = "IVu0AtTZ04G1lZuw-77ZFA"; // Replace with your actual API key
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ur"],
    ns: ["default"],
    defaultNS: "default",
    backend: { loadPath: loadPath },
    debug: true, // Enable to check errors in the console
  });

export default i18next;
